import { render, staticRenderFns } from "./MyQuotesDetailsPanel.vue?vue&type=template&id=7bbc05f6&scoped=true"
import script from "./MyQuotesDetailsPanel.vue?vue&type=script&lang=ts"
export * from "./MyQuotesDetailsPanel.vue?vue&type=script&lang=ts"
import style0 from "./MyQuotesDetailsPanel.vue?vue&type=style&index=0&id=7bbc05f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc05f6",
  null
  
)

export default component.exports